import React from 'react'
import Typed from 'react-typed';
export default function Banner() {
    return (
        <div className=' bg-[#3699fb] w-full py-[100px]'>
            <div className=" max-w-[1240px]  my-[90px] mx-auto font-bold text-center">



                <div className=' text-xl md:text-3xl  md:p-3  '>Learn with us</div>
                <div className='text-xl md:text-[60px]md:p-3 text-white  '>Grow with us</div>
                <div className=' text-xl md:text-[60px] md:p-7  text-white '>Learn
                    <Typed
                        className='pl-3'
                        strings={['  Web Development', 'Digital Marketing', ' Complete JavaScript', 'Cyber Security']}
                        typeSpeed={100}
                        loop={true}
                        backSpeed={80}
                    />
                </div>
                <button className=' bg-black hover:bg-blue-500 text-white font-bold py-2 mt-4 px-4 border border-blue-700 rounded'>Get Started</button>
            </div>
        </div>
    )
}
